/**
 * 主要针对与 交易日志的中英对照表
 */

 //数据字典对照表
 const dict ={
   //订单操作枚举
   orderStrategy:"{orderStrategy,select, BUY{新增订单} RENEW{续签} ADD{增加功能} other{未知}}",
   //类型枚举
   orderType:"{orderType,select, GENERAL{普通订单} LIFELONG{终身订单} other{未知}}",
   //剩余时间类型
   priceType:"{priceType,select,YEAR{年} MONTH{月} DAY{日} other{其他方案} }",
   //付款类型
   payStrategy:"{payStrategy, select, AGENT_PAYMENT{代理支付} CORPORATE_PAYMENT{企业支付} TOGETHER_PAYMENT{合并支付} other{未知}}",
   //功能标签
   funcLabel:"{funcLabel , select , TALKIE{对讲} LOCATION{定位}  other{未知} }"


}
// 新增订单，订单号xxxx。企业账号:xxxx。个数:xx ，剩余时长 
// 付款明细
// 对讲 xxx时间 单价 xxx/n 总
//

const payLog = {
   dict:dict,
   CORPORATE_PAYMENT:"@:payLog.dict.orderStrategy , 订单号:{orderId} 企业账号:{ownerAccount}, 个数:{num} ,剩余时长:{timeLeft}/@:payLog.dict.priceType,支付:{pays} ",
   // details:'账号数:{count},功能:@:payLog.dict.funcLabel,功能单价:{price}/@:payLog.dict.priceType 剩余时长：{duration}/@:payLog.dict.priceType 功能总价:{value}',
   details:'功能: @:payLog.dict.funcLabel, 功能单价:{price}/@:payLog.dict.priceType  功能总价:{value}',
}


export default payLog;


// WEBPACK FOOTER //
// ./src/api/lang/modules/oplog/PayLog_en.js